import PropTypes from 'prop-types'
import { DriverRoles } from '../../models/drivers/driver-roles-enum'
import { ObjectDriverAssignmentTypes } from '../../models/drivers/object-driver-assignment-types-enum'
import { idPropType } from '../common/id-prop-type'
import { iso8601PropType } from '../common/iso-8601-prop-type'

/**
 * @typedef {Object} CurrentDriverObjectAssignment
 * @property {ISO8601}                      driverAssignmentModifyTime - Timestamp at which the driver has been assigned
 *                                                                      to the object. Format: ISO 8601 datetime string.
 * @property {ObjectDriverAssignmentTypes}  driverAssignmentType
 * @property {DriverRoles}                  driverRole
 * @property {Id}                           objectId
 */
export const currentDriverObjectAssignmentPropType = PropTypes.shape({
    driverAssignmentModifyTime: iso8601PropType.isRequired,
    driverAssignmentType: PropTypes.oneOf(Object.values(ObjectDriverAssignmentTypes)).isRequired,
    driverRole: PropTypes.oneOf(Object.values(DriverRoles)).isRequired,
    objectId: idPropType.isRequired
})
